/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Evolink_DescriptionInputs */

const en_admin_settings_groups_evolink_description = /** @type {(inputs: Admin_Settings_Groups_Evolink_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evolink AI API (image, video, chat)`)
};

/**
* | output |
* | --- |
* | "Evolink AI API (image, video, chat)" |
*
* @param {Admin_Settings_Groups_Evolink_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_evolink_description = /** @type {((inputs?: Admin_Settings_Groups_Evolink_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Evolink_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_evolink_description(inputs)
});
export { admin_settings_groups_evolink_description as "admin.settings.groups.evolink.description" }